export function det4(M: number[][]): number {
  const d00 = M[1][1] * (M[2][2] * M[3][3] - M[2][3] * M[3][2])
            - M[1][2] * (M[2][1] * M[3][3] - M[2][3] * M[3][1])
            + M[1][3] * (M[2][1] * M[3][2] - M[2][2] * M[3][1]);
  const d01 = M[1][0] * (M[2][2] * M[3][3] - M[2][3] * M[3][2])
            - M[1][2] * (M[2][0] * M[3][3] - M[2][3] * M[3][0])
            + M[1][3] * (M[2][0] * M[3][2] - M[2][2] * M[3][0]);
  const d02 = M[1][0] * (M[2][1] * M[3][3] - M[2][3] * M[3][1])
            - M[1][1] * (M[2][0] * M[3][3] - M[2][3] * M[3][0])
            + M[1][3] * (M[2][0] * M[3][1] - M[2][1] * M[3][0]);
  const d03 = M[1][0] * (M[2][1] * M[3][2] - M[2][2] * M[3][1])
            - M[1][1] * (M[2][0] * M[3][2] - M[2][2] * M[3][0])
            + M[1][2] * (M[2][0] * M[3][1] - M[2][1] * M[3][0]);
  return M[0][0] * d00 - M[0][1] * d01 + M[0][2] * d02 - M[0][3] * d03;
}

export function solveCramer4(M: number[][], f: number[]): number[] {
  const d = det4(M);
  const inv = 1 / d;

  function replaceCol(col: number, val: number[]): number[][] {
    return M.map((row, r) => row.map((v, c) => c === col ? val[r] : v));
  }

  return [
    det4(replaceCol(0, f)) * inv,
    det4(replaceCol(1, f)) * inv,
    det4(replaceCol(2, f)) * inv,
    det4(replaceCol(3, f)) * inv,
  ];
}

export function solveCramer2(
  a00: number, a01: number,
  a10: number, a11: number,
  f0: number, f1: number,
): [number, number] {
  const det = a00 * a11 - a01 * a10;
  const inv = 1 / det;
  return [(f0 * a11 - a01 * f1) * inv, (a00 * f1 - f0 * a10) * inv];
}
